// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testInstanceId } from './TestInstance';
import { testTemplateAttributeId } from './TestTemplateAttribute';
import { operatorId } from './Operator';
import { invItemId } from './InvItem';
import { fileStorageId } from './FileStorage';
import { testAttributeCodeCode } from './TestAttributeCode';
import { resultQualifierEnum } from './ResultQualifierEnum';
import { z } from 'zod';
export const testInstanceAttributeId = (z.number());
export const testInstanceAttribute = z.object({
    id: testInstanceAttributeId,
    test_instance_id: testInstanceId,
    test_template_attribute_id: testTemplateAttributeId.nullable(),
    display_order: z.number().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    is_specification: z.boolean(),
    spec_details: z.string().nullable(),
    spec_target_value_number: z.string().nullable(),
    spec_abs_tol_upper: z.string().nullable(),
    spec_abs_tol_lower: z.string().nullable(),
    spec_target_value_unit: z.string().nullable(),
    spec_target_check_value: z.boolean().nullable(),
    number_value: z.string().nullable(),
    measurement_unit: z.string().nullable(),
    check_value: z.boolean().nullable(),
    timestamp_value: z.date().nullable(),
    text_value: z.string().nullable(),
    inventory_item_id: invItemId.nullable(),
    media_attachment_file_storage_id: fileStorageId.nullable(),
    note: z.string().nullable(),
    computed_number: z.string().nullable(),
    computed_number_unit: z.string().nullable(),
    computed_number_status: z.string().nullable(),
    computed_number_eval_error: z.unknown().nullable(),
    attribute_code: testAttributeCodeCode.nullable(),
    qualifier: resultQualifierEnum,
    limit_value: z.string().nullable(),
    uncertainty: z.string().nullable(),
    raw_text: z.string().nullable(),
    flags: z.string().array(),
    remark: z.string().nullable(),
});
export const testInstanceAttributeInitializer = z.object({
    id: testInstanceAttributeId.optional(),
    test_instance_id: testInstanceId,
    test_template_attribute_id: testTemplateAttributeId.optional().nullable(),
    display_order: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    is_specification: z.boolean().optional(),
    spec_details: z.string().optional().nullable(),
    spec_target_value_number: z.string().optional().nullable(),
    spec_abs_tol_upper: z.string().optional().nullable(),
    spec_abs_tol_lower: z.string().optional().nullable(),
    spec_target_value_unit: z.string().optional().nullable(),
    spec_target_check_value: z.boolean().optional().nullable(),
    number_value: z.string().optional().nullable(),
    measurement_unit: z.string().optional().nullable(),
    check_value: z.boolean().optional().nullable(),
    timestamp_value: z.date().optional().nullable(),
    text_value: z.string().optional().nullable(),
    inventory_item_id: invItemId.optional().nullable(),
    media_attachment_file_storage_id: fileStorageId.optional().nullable(),
    note: z.string().optional().nullable(),
    computed_number: z.string().optional().nullable(),
    computed_number_unit: z.string().optional().nullable(),
    computed_number_status: z.string().optional().nullable(),
    computed_number_eval_error: z.unknown().optional().nullable(),
    attribute_code: testAttributeCodeCode.optional().nullable(),
    qualifier: resultQualifierEnum.optional(),
    limit_value: z.string().optional().nullable(),
    uncertainty: z.string().optional().nullable(),
    raw_text: z.string().optional().nullable(),
    flags: z.string().array().optional(),
    remark: z.string().optional().nullable(),
});
export const testInstanceAttributeMutator = z.object({
    id: testInstanceAttributeId.optional(),
    test_instance_id: testInstanceId.optional(),
    test_template_attribute_id: testTemplateAttributeId.optional().nullable(),
    display_order: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    is_specification: z.boolean().optional(),
    spec_details: z.string().optional().nullable(),
    spec_target_value_number: z.string().optional().nullable(),
    spec_abs_tol_upper: z.string().optional().nullable(),
    spec_abs_tol_lower: z.string().optional().nullable(),
    spec_target_value_unit: z.string().optional().nullable(),
    spec_target_check_value: z.boolean().optional().nullable(),
    number_value: z.string().optional().nullable(),
    measurement_unit: z.string().optional().nullable(),
    check_value: z.boolean().optional().nullable(),
    timestamp_value: z.date().optional().nullable(),
    text_value: z.string().optional().nullable(),
    inventory_item_id: invItemId.optional().nullable(),
    media_attachment_file_storage_id: fileStorageId.optional().nullable(),
    note: z.string().optional().nullable(),
    computed_number: z.string().optional().nullable(),
    computed_number_unit: z.string().optional().nullable(),
    computed_number_status: z.string().optional().nullable(),
    computed_number_eval_error: z.unknown().optional().nullable(),
    attribute_code: testAttributeCodeCode.optional().nullable(),
    qualifier: resultQualifierEnum.optional(),
    limit_value: z.string().optional().nullable(),
    uncertainty: z.string().optional().nullable(),
    raw_text: z.string().optional().nullable(),
    flags: z.string().array().optional(),
    remark: z.string().optional().nullable(),
});
//# sourceMappingURL=TestInstanceAttribute.js.map